if (!customElements.get('product-ring-size-chart')) {
  class ProductRingSizeChart extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dialog = this.querySelector('dialog');
      this.openButton = this.querySelector('[data-ring-chart-open]');
      this.closeButton = this.querySelector('[data-ring-chart-close]');

      if (!this.dialog || !this.openButton || !this.closeButton) return;

      this.dataset.initialized = 'true';
      this.handleOpen = () => this.dialog.showModal();
      this.handleClose = () => this.dialog.close();
      this.handleBackdrop = (event) => {
        if (event.target === this.dialog) this.dialog.close();
      };
      this.handleDialogClose = () => this.openButton.focus();

      this.openButton.addEventListener('click', this.handleOpen);
      this.closeButton.addEventListener('click', this.handleClose);
      this.dialog.addEventListener('click', this.handleBackdrop);
      this.dialog.addEventListener('close', this.handleDialogClose);
    }

    disconnectedCallback() {
      if (!this.dataset.initialized) return;

      this.openButton?.removeEventListener('click', this.handleOpen);
      this.closeButton?.removeEventListener('click', this.handleClose);
      this.dialog?.removeEventListener('click', this.handleBackdrop);
      this.dialog?.removeEventListener('close', this.handleDialogClose);
      this.dataset.initialized = 'false';
    }
  }

  customElements.define('product-ring-size-chart', ProductRingSizeChart);
}
